//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACTION_SHOW_ACCOUNT_BULLET } from '@/scripts/store/header/actions'

import RbPromoBadge from '@/elements/product-tile/product-tile-header/product-tile-promo-badge/product-tile-promo-badge.vue'
import RbProductTileStatusMessage from '@/elements/product-tile/product-tile-header/product-tile-status-message/product-tile-status-message.vue'
import { createNamespacedHelpers, mapActions, mapGetters } from 'vuex'
import { ACTION_ADD_TO_WISHLIST, ACTION_REMOVE_FROM_WISHLIST } from '@/scripts/store/actions'
const { mapActions: mapActionsHeader } = createNamespacedHelpers('header')
export default {
  name: 'product-tile-header',
  components: {
    RbPromoBadge,
    RbProductTileStatusMessage,
  },
  inject: ['isLoading', 'getIsTileFocused', 'handleWishlistModal'],
  props: {
    currentPromotion: {
      type: Object,
      default: () => ({}),
    },
    selectedVariant: {
      type: Object,
      default: () => ({}),
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['wishlistItems']),
    productIsInsideWishlist() {
      return !!this.wishlistItems.find(
        (item) => item.catentryId === this.selectedVariant.catEntryId
      )
    },
    isTileFocused() {
      return this.getIsTileFocused()
    },
    wishlistHeart() {
      return this.productIsInsideWishlist ? 'red-heart' : 'heart'
    },
    whishlistButtonTabIndex() {
      return this.isTileFocused ? '0' : '-1'
    },
  },
  beforeMount() {
    sessionStorage.setItem('wishlistedItems', 0)
  },
  methods: {
    ...mapActions({
      addToWishlist: ACTION_ADD_TO_WISHLIST,
      removeFromWishlist: ACTION_REMOVE_FROM_WISHLIST,
    }),
    ...mapActionsHeader({
      showAccountBullet: ACTION_SHOW_ACCOUNT_BULLET,
    }),
    toggleWishlist() {
      const newWishlistedItems = parseInt(sessionStorage.getItem('wishlistedItems')) || 1
      if (this.productIsInsideWishlist) {
        this.removeFromWishlist({ wishlistItemId: this.selectedVariant.catEntryId })
        if (newWishlistedItems > 0) {
          sessionStorage.setItem('wishlistedItems', newWishlistedItems - 1)
        }
        return
      }

      this.addToWishlist({ catEntry: this.selectedVariant.catEntryId, mq: false })
      if (newWishlistedItems <= 3 && !this.productIsInsideWishlist) {
        sessionStorage.setItem('wishlistedItems', newWishlistedItems + 1)
      }
      this.$nextTick(() => {
        this.handleWishlistModal(newWishlistedItems)
      })
      this.showAccountBullet()
    },
  },
}
